module.exports = __webpack_public_path__ + "quilt3-level3.55fb59a7.png";